import React from 'react';

// Fonction pour déterminer l'attribut autoComplete approprié
const getAutoComplete = (name, type) => {
  const autoCompleteMap = {
    nom: 'name',
    nomComplet: 'name',
    name: 'name',
    prenom: 'given-name',
    email: 'email',
    telephone: 'tel',
    tel: 'tel',
    phone: 'tel',
    ville: 'address-level2',
    region: 'address-level1',
    address: 'street-address',
    adresse: 'street-address',
    dateNaissance: 'bday',
    age: 'off',
    salaire: 'off',
    entreprise: 'organization',
    poste: 'organization-title',
    formateur: 'off',
    promotion: 'off',
    notes: 'off',
    commentaire: 'off',
    contactSuperviseur: 'tel',
    nouveauPoste: 'organization-title'
  };

  // Si le nom est dans la map, utiliser cette valeur
  if (autoCompleteMap[name?.toLowerCase()]) {
    return autoCompleteMap[name.toLowerCase()];
  }

  // Sinon, selon le type
  if (type === 'email') return 'email';
  if (type === 'tel') return 'tel';
  if (type === 'password') return 'new-password';
  if (type === 'date') return 'off';
  if (type === 'number') return 'off';

  return 'off';
};

const FormInput = ({ label, type = 'text', value, onChange, required, placeholder, error, name, id, ...props }) => {
  // Générer un ID unique basé sur le name ou utiliser celui fourni
  const inputId = id || (name ? `input-${name}` : `input-${Math.random().toString(36).substr(2, 9)}`);
  const autoComplete = getAutoComplete(name, type);

  if (type === 'textarea') {
    return (
      <div>
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium mb-1">
            {label} {required && <span className="text-red-600">*</span>}
          </label>
        )}
        <textarea
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          autoComplete={autoComplete}
          rows={props.rows || 3}
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-red-600" role="alert">{error}</p>}
      </div>
    );
  }

  return (
    <div>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium mb-1">
          {label} {required && <span className="text-red-600">*</span>}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-600" role="alert">{error}</p>}
    </div>
  );
};

export default FormInput;

